module.exports = __webpack_public_path__ + "img/memo_1793270565484_27900.004e0f95.jpg";